export default "__VITE_ASSET__Q0mxuCCG__"